import React, { Component } from 'react';

class TestContent01 extends Component {
  render() {
    return (
      <div>
        <p>{this.props.flag && "trueです" || "falseです"} </p>
        <p>{this.props.index} </p>
      </div>
    )
  }
}

export default TestContent01;